/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fw_Storypage_IntroInputs */

const en_fw_storypage_intro = /** @type {(inputs: Fw_Storypage_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A spoiler-light guide to the Firefly Wedding story, from the kidnapping that starts it all to the world Satoko and Shinpei move through.`)
};

const zh_fw_storypage_intro = /** @type {(inputs: Fw_Storypage_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`从引出一切的那场绑架，到紗都子与進平所处的世界，这是一份轻剧透的萤火之嫁剧情指南。`)
};

/**
* | output |
* | --- |
* | "A spoiler-light guide to the Firefly Wedding story, from the kidnapping that starts it all to the world Satoko and Shinpei move through." |
*
* @param {Fw_Storypage_IntroInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const fw_storypage_intro = /** @type {((inputs?: Fw_Storypage_IntroInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fw_Storypage_IntroInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_fw_storypage_intro(inputs)
	return zh_fw_storypage_intro(inputs)
});
export { fw_storypage_intro as "fw.storypage.intro" }